import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=73b529c5&"
import script from "./TermsOfUse.vue?vue&type=script&lang=js&"
export * from "./TermsOfUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
